import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Link } from "react-router-dom";
import "react-tabs/style/react-tabs.css";
import home from "../../../../common/assets/data/home";
import Container from "../../../utility/ui-components/container";
import Section from "../../../utility/ui-components/section";
import SectionHeading from "../../../utility/ui-components/sectionHeading";
import Button from "../../../utility/ui-components/button";
import ScrollAnimation from "react-animate-on-scroll";
import RotateImage from "../../../utility/ui-components/images/rotateImage";
function Products() {
  const data = home.ProductsSection;
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 1920, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <Section>
      <Container>
      <ScrollAnimation  animateIn="animate__fadeIn">
        <SectionHeading heading={data.Heading} />
        </ScrollAnimation>
        {data && (
          <Tabs
            className={
              "border-solid border-2 border-primary shadow-lg p-2 rounded"
            }
          >
            <TabList
              className={
                "grid grid-cols-1 md:grid-cols-2 mb-4 border-2 border-secondary  border-dashed rounded"
              }
            >
              {data.TabItems.map((items, index) => (
                <Tab
                  key={index + 1}
                  allowFullScreen
                  className={" text-lg md:text-xl p-2 text-center"}
                >
                  {items.Heading}
                </Tab>
              ))}
            </TabList>
            {data.TabItems.map((items, index) => (
              <TabPanel key={index + 1}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="p-2">
                    <h2 className="mb-2 text-xl md:text-2xl font-semibold">
                      {items.Heading}
                    </h2>
                    <p className="mb-2 text-base md:text-lg">{items.Paragraph}</p>
                    {items.buttons.map((button, index) => (
                      <div  className="text-center md:text-left">
                      <Link to={button.path}>
                      <Button  type="button" key={index + 1} button={button} />
                      </Link>
                        </div>
                    ))}
                  </div>
                  <Carousel
                    responsive={responsive}
                    autoPlay={true}
                    autoPlaySpeed={2000}
                    arrows={false}
                    showDots={false}
                    rewind={true}
                    infinite
                  >
                    {items.ProductImages.map((data, index) => (
                      <div key={index + 1} className="max-h-[300px]">
                        <RotateImage Imgsrc={data}/>
               
                        {/* <img
                          className="object-fill object-center blur-[1px] pointer-events-none"
                          src={data.image}
                          alt="image"
                        /> */}

                      </div>
                    ))}
                  </Carousel>
                </div>
              </TabPanel>
            ))}
          </Tabs>
        )}
      </Container>
    </Section>
  );
}

export default Products;
